import React from 'react';
import PropTypes from 'prop-types';

import { looks, sizes } from './Button.variants';
import StyledButton from './Button.styled';

const Button = React.forwardRef(
  (
    {
      children,
      look,
      size,
      onClick,
      disabled,
      label,
      fullWidth,
      startIcon,
      endIcon,
      testId,
    },
    ref
  ) => (
    <StyledButton
      onClick={onClick}
      look={looks[look]}
      size={sizes[size]}
      disabled={disabled}
      aria-label={label}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      ref={ref}
      data-testid={testId}
    >
      {children}
    </StyledButton>
  )
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  look: PropTypes.oneOf(Object.keys(looks)),
  size: PropTypes.oneOf(Object.keys(sizes)),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  fullWidth: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  testId: PropTypes.string,
};

Button.defaultProps = {
  look: 'primary',
  size: 'default',
  onClick: null,
  disabled: false,
  label: '',
  fullWidth: false,
  startIcon: null,
  endIcon: null,
  testId: '',
};

export default Button;
